import { render, staticRenderFns } from "./StatisticCard.vue?vue&type=template&id=fbfd005a&scoped=true&"
import script from "./StatisticCard.vue?vue&type=script&lang=js&"
export * from "./StatisticCard.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCard.vue?vue&type=style&index=0&id=fbfd005a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfd005a",
  null
  
)

export default component.exports